import Vue from 'vue'
import Router from 'vue-router'
import login from '@/login'
import topicIndex from '@/question/index'
import topicList from '@/question/topic'
import topicVideo from '@/question/video'
import labelIndex from '@/label/index'
import labelType from '@/label/type'
import teacher from '@/teacher/index'
import student from '@/student/index'
import accounts from '@/accounts/index'
import user from '@/user/index'
import marketIndex from '@/marketing/index'
import explain from '@/marketing/explain'
import exercises from '@/marketing/exercises'
import work from '@/marketing/work'
import marketResult from '@/marketing/result'
import identityLogin from '@/identity/login'
import identityIndex from '@/identity/index'
import identityList from '@/identity/list'
import identityVideo from '@/identity/video'
import videoDetail from '@/identity/videoDetail'
import videoTopic from '@/identity/videoTopic'
import videoComment from '@/identity/videoComment'
import exam from '@/identity/exam'
import examTopic from '@/identity/examTopic'
import examReplay from '@/identity/examReplay'
import examComment from '@/identity/examComment'
import wrong from '@/identity/wrong'
import wrongTopic from '@/identity/wrongTopic'
import wrongComment from '@/identity/wrongComment'
import result from '@/identity/result'
import parent from '@/identity/parent'
import examSite from '@/identity/examSite'
import studyIndex from '@/study/index'
import studyHistory from '@/study/history'
import studyPaper from '@/study/paper'
import studyModule from '@/study/module'
import solveIndex from '@/solve/index'
import solveVideo from '@/solve/video'
import compositionList from '@/composition/index'
import classicList from '@/classic/index'
import examBigTopic from '@/identity/examBigTopic'
import aikeywords from '@/ai/keywords'
import aichat from '@/ai/chat'


Vue.use(Router)

export default new Router({
  mode:'hash',
  routes: [
    {
      path: '/',
      name: 'login',
      component: login,
      meta:{
        title:'登录'
      }
    },
    {
      path: '/topicIndex',
      name: 'topicIndex',
      component: topicIndex,
      meta:{
        title:'题库管理'
      }
    },
    {
      path: '/topicVideo',
      name: 'topicVideo',
      component: topicVideo,
      meta:{
        title:'视频课程'
      }
    },
    {
      path: '/labelIndex',
      name: 'labelIndex',
      component: labelIndex,
      meta:{
        title:'标签管理'
      }
    },
    {
      path: '/labelType',
      name: 'labelType',
      component: labelType,
      meta:{
        title:'标签类型管理'
      }
    },
    {
      path: '/teacher',
      name: 'teacher',
      component: teacher,
      meta:{
        title:'老师管理'
      }
    },
    {
      path: '/student',
      name: 'student',
      component: student,
      meta:{
        title:'学员管理'
      }
    },
    {
      path: '/accounts',
      name: 'accounts',
      component: accounts,
      meta:{
        title:'账户信息'
      }
    },
    {
      path: '/user',
      name: 'user',
      component: user,
      meta:{
        title:'租户管理'
      }
    },
    {
      path: '/marketIndex',
      name: 'marketIndex',
      component: marketIndex,
      meta:{
        title:'营销管理'
      }
    },
    {
      path: '/explain',
      name: 'explain',
      component: explain,
      meta:{
        title:'母题讲解练习'
      }
    },
    {
      path: '/exercises',
      name: 'exercises',
      component: exercises,
      meta:{
        title:'习题刻意练习'
      }
    },
    {
      path: '/marketResult',
      name: 'marketResult',
      component: marketResult,
      meta:{
        title:'报告'
      }
    },
    {
      path: '/work',
      name: 'work',
      component: work,
      meta:{
        title:'作业'
      }
    },
    {
      path: '/identityLogin',
      name: 'identityLogin',
      component: identityLogin,
      meta:{
        title:'身份登录'
      }
    },
    {
      path: '/identityIndex',
      name: 'identityIndex',
      component: identityIndex,
      meta:{
        title:'选择训练营'
      }
    },
    {
      path: '/identityList',
      name: 'identityList',
      component: identityList,
      meta:{
        title:'拆解训练营'
      }
    },
    {
      path: '/identityVideo',
      name: 'identityVideo',
      component: identityVideo,
      meta:{
        title:'母题讲解练习'
      }
    },
    {
      path: '/videoDetail',
      name: 'videoDetail',
      component: videoDetail,
      meta:{
        title:'母题视频'
      }
    },
    {
      path: '/videoTopic',
      name: 'videoTopic',
      component: videoTopic,
      meta:{
        title:'母题讲解'
      }
    },
    {
      path: '/videoComment',
      name: 'videoComment',
      component: videoComment,
      meta:{
        title:'母题点评'
      }
    },
    {
      path: '/exam',
      name: 'exam',
      component: exam,
      meta:{
        title:'习题刻意练习'
      }
    },
    {
      path: '/examTopic',
      name: 'examTopic',
      component: examTopic,
      meta:{
        title:'习题刻意练习题'
      }
    },
    {
      path: '/examReplay',
      name: 'examReplay',
      component: examReplay,
      meta:{
        title:'习题刻意练习复盘'
      }
    },
    {
      path: '/examComment',
      name: 'examComment',
      component: examComment,
      meta:{
        title:'习题刻意练习复盘'
      }
    },
    {
      path: '/wrong',
      name: 'wrong',
      component: wrong,
      meta:{
        title:'错题'
      }
    },
    {
      path: '/wrongTopic',
      name: 'wrongTopic',
      component: wrongTopic,
      meta:{
        title:'错题详情'
      }
    },
    {
      path: '/wrongComment',
      name: 'wrongComment',
      component: wrongComment,
      meta:{
        title:'错题点评'
      }
    },
    {
      path: '/result',
      name: 'result',
      component: result,
      meta:{
        title:'报告'
      }
    },
    {
      path: '/parent',
      name: 'parent',
      component: parent,
      meta:{
        title:'家长'
      }
    },
    {
      path: '/examSite',
      name: 'examSite',
      component: examSite,
      meta:{
        title:'考情诊断'
      }
    },
    {
      path: '/studyIndex',
      name: 'studyIndex',
      component: studyIndex,
      meta:{
        title:'考情诊断'
      }
    },
    {
      path: '/studyHistory',
      name: 'studyHistory',
      component: studyHistory,
      meta:{
        title:'历史学情'
      }
    },
    {
      path: '/studyPaper',
      name: 'studyPaper',
      component: studyPaper,
      meta:{
        title:'试卷管理'
      }
    },
    {
      path: '/studyModule',
      name: 'studyModule',
      component: studyModule,
      meta:{
        title:'板块与考点管理'
      }
    },
    {
      path: '/solveIndex',
      name: 'solveIndex',
      component: solveIndex,
      meta:{
        title:'反向解题习题题库'
      }
    },
    {
      path: '/solveVideo',
      name: 'solveVideo',
      component: solveVideo,
      meta:{
        title:'反向解题母题题库'
      }
    },
    {
      path: '/compositionList',
      name: 'compositionList',
      component: compositionList,
      meta:{
        title:'作文--习题题库'
      }
    },
    {
      path: '/classicList',
      name: 'classicList',
      component: classicList,
      meta:{
        title:'名著阅读--母题题库'
      }
    },
    {
      path: '/examBigTopic',
      name: 'examBigTopic',
      component: examBigTopic,
      meta:{
        title:'大题列表'
      }
    },
    {
      path: '/aikeywords',
      name: 'aikeywords',
      component: aikeywords,
      meta:{
        title:'ai关键词'
      }
    },
    {
      path: '/aichat',
      name: 'aichat',
      component: aichat,
      meta:{
        title:'ai聊天'
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js